export default "/images/vendor/@coreui/icons/svg/flag/cif-bz.svg?cb4b232a8ea2fb9c4419985f99249304";